<template>
  <div>
    <div >
      <InputSearch class="mb-3" @clickSearch="onSearch" :search="search" :placeholder="'ค้นหา'" />
      <v-layout row wrap dense class="mb-3">
        <v-flex xs6 style="display: flex; align-items: center">
          <Typography h2 bold :label="`ข้อม​ูลประเภทโครงการ`" />
        </v-flex>
        <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
          <div class="text-xs-right" style="display: flex; align-items: flex-end">
            <v-btn
              variant="outlined"
              v-tooltip="'เพิ่ม'"
              :loading="loading"
              @click="showAdd"
              icon
              color="#BECCDB"
              style="border-radius: 50% !important"
            >
              <img src="/static/img/Add.png" alt class="responsive-img" style="height: 20px" />
            </v-btn>
            <!-- <v-btn
                small
                @click="showSearch = true"
                :style="
                  `color: ${$vuetify.theme.primary};  text-transform: capitalize;position:relative;`
                "
                :color="`color: ${$vuetify.theme.primary}`"
                outline
                ><i class="fas fa-search mr-1"></i>{{ $t('Search') }}
                <div v-if="isSearching" style="position: absolute; right: -28px; top: -26px">
                  <v-btn @click.stop="clearSearch" dark small icon color="red">
                    <v-icon small>close</v-icon>
                  </v-btn>
                </div></v-btn
              > -->
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="data"
          hide-actions
          select-all
          item-key="name"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="(header, k) in props.headers"
                :key="header.text + k"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-xs-left">
                <Typography
                  style="width: 100px; overflow-wrap: break-word"
                  h5
                  :label="props.item.id"
                />
              </td>
              <td class="text-xs-left">
                <Typography
                  style="width: 150px; overflow-wrap: break-word"
                  h5
                  :label="props.item.projecttypeno"
                />
              </td>
              <td class="text-xs-left">
                <Typography
                  style="width: 500px; overflow-wrap: break-word"
                  h5
                  :label="props.item.typename"
                />
              </td>
              <td class="text-xs-left">
                <div
                  v-if="props.item.typedata && getTypeData(props.item.typedata).length"
                  class="py-2"
                >
                  <div v-for="(item, k) in getTypeData(props.item.typedata)" :key="k">
                    <Typography style="width: 250px; overflow-wrap: break-word" h5 :label="item" />
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td style="white-space: nowrap" @click.stop="">
                <TooltipTable
                  @modalEdit="showEdit(props.item)"
                  @Delete="deleteType(props.item.id)"
                  :datas="props"
                  showDelete
                ></TooltipTable>
              </td>
            </tr>
          </template>
        </v-data-table>
        <Paginations
          @clickPagination="changePage"
          @sortPage="sortPage"
          :numberPage="numberPage"
          :pageCount="pageCount"
          :page="page"
        />
        <div>
          <v-dialog v-model="editModal" persistent width="590px">
            <project-type-edit
              :editType="editType"
              @closemodal="closemodal"
              @saveedit="saveedit"
              @onCreate="onCreate"
              @onUpdate="onUpdate"
              v-if="editModal"
              :inputdata="inputData"
            ></project-type-edit>
          </v-dialog>
        </div>
      </div>
    </div>
    <!-- <v-dialog v-model="showSearch" width="500px" persistent>
      <v-card>
        <v-btn style="float: right" @click="showSearch = false" icon><v-icon>close</v-icon></v-btn>
        <div class="pa-3">
          <span style="font-weight: 600; font-size: 23px" class="rsu">
            ค้นหา <v-icon size="36px">search</v-icon>
          </span>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2">
                <div>
                  <div class="pr-3" style="white-space: nowrap">ชื่อประเภทโครงการ</div>
                  <div style="width: 100%" class="form-control">
                    <input
                      name="ชื่อประเภทโครงการ"
                      placeholder="กรอกชื่อประเภทโครงการ"
                      v-model="search.typename"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn class="rsu" @click="clearSearch" round small outline color="primary">{{
                  $t('Clear')
                }}</v-btn>
                <v-btn
                  class="rsu"
                  @click="onSearch"
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  >{{ $t('Search') }}</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import ProjectTypeEdit from './ProjectTypeEdit.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Typography from '@/components/elements/Typography.vue'
import Paginations from '@/components/elements/Paginations.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: { ProjectTypeEdit, DropdownMenu, InputSearch, TooltipTable, Typography, Paginations },
  computed: {
    ...mapGetters(['selectedBot']),
    pageCount() {
      if (this.typeTotal !== 0) {
        let count = Math.ceil(this.typeTotal / this.limit)
        return count
      } else {
        return 0
      }
    }
  },
  data() {
    return {
      loading: false,
      showSearch: false,
      search: {
        nameAll: ''
      },
      test: false,
      pagination: {
        sortBy: 'name'
      },
      numberPage: {
        page: undefined
      },
      inputData: {},
      editModal: false,
      formdata: [],
      data: [],
      editType: '',
      limit: 10,
      page: 1,
      typeTotal: 0,
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'รหัสประเภทโครงการ',
          align: 'left',
          value: 'projecttypeno'
        },
        {
          text: 'ประเภทโครงการ',
          align: 'left',
          value: 'typename'
        },
        {
          text: 'กระบวนการ',
          align: 'left',
          value: 'typedata_name'
        },

        {
          text: '',
          align: 'center',
          value: ''
        }
      ],
      searchloading: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      await this.getFormData()
      await this.getProjectType()
      this.loading = false
    },
    async changePage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.searchloading = true
      await this.getProjectType()
      this.searchloading = false
      this.showSearch = false
    },
    async sortPage(pages) {
      if (pages == '' || +pages <= 0 || +pages > this.pageCount) return
      this.page = parseInt(pages)
      this.loading = true
      await this.getProjectType()
      this.loading = false
    },
    async onSearch() {
      this.searchloading = true
      this.page = 1
      this.numberPage.page = 1
      await this.getProjectType()
      this.searchloading = false
      this.showSearch = false
    },
    async clearSearch() {
      this.search = { nameAll: '' }
      this.searchloading = true
      await this.getProjectType()
      this.searchloading = false
      this.showSearch = false
    },
    onUpdate(data) {
      var index = this.data.findIndex(el => el.id == data.id)

      this.$set(this.data, index, data)
      this.$nextTick(() => {
        this.editModal = false
      })
    },
    deleteType(id) {
      this.$swal
        .fire({
          title:
            '<img src="/static/img/delete.png" alt class="responsive-img mt-4" style="height: 73px" />',
          html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">คุณต้องการลบประเภทโครงการนี้ใช่หรือไม่</div>`,
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            api.deletedepaprojecttype({ typeid: id }, (err, response) => {
              if (response.responsecode == 200) {
                // var index = this.data.findIndex(el => el.id == id)
                // this.data.splice(index, 1)
                this.fetchData()
                this.$swal.fire({
                  type: 'success',
                  title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              }
              if (this.data.length == 1) {
                this.page = this.page - 1
                this.fetchData()
              }
            })
          }
        })
    },
    getTypeData(data) {
      return data.map(el => el.name)
    },
    getProjectType() {
      this.loading = true
      return new Promise(resolve => {
        api.getdepaprojecttype(
          {
            typename: this.search.nameAll,
            limit: this.limit,
            offset: (this.page - 1) * this.limit
          },
          (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              this.typeTotal = response.total
              this.data = response.data.map(el => {
                return { ...el, typedata: JSON.parse(el.typedata) }
              })
            }
            resolve()
          }
        )
        //        api.getdepaprojecttype({ typename: this.search.nameAll, limit: this.limit, offset: (this.page - 1) * this.limitt, nameAll: this.search.nameAll }, (err, response) => {
        //           this.loading = false
        //           if (response.responsecode == 200) {
        //             this.data = response.data.map((el) => {
        //               return { ...el, typedata: JSON.parse(el.typedata) }
        //             })
        //           }
        //            console.log("getProjectType", this.data);
        //           resolve()
        //         })
      })
    },
    getFormData() {
      this.loading = true
      return new Promise(resolve => {
        api.getdepaprojectform({}, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.$store.state.formdata = response.data
          }
          console.log('getFormdata', this.$store.state.formdata)
          resolve()
        })
      })
    },
    async onCreate(item) {
      this.editModal = false
      this.fetchData()
    },
    getdepamembertypeall() {
      api.getdepamembertypeall({ pageid: this.selectedBot.pageid })
    },
    statusColor(status) {
      if (status == 'Active') return 'green'
      else if (status == 'Inactive') return 'red'
    },
    saveedit(item) {
      var index = this.data.findIndex(el => el.id == item.id)
      this.data[index] = item
      this.editModal = false
    },
    closemodal() {
      this.editModal = false
    },
    showEdit(item) {
      api.depacheckprojectusedtypebyid(
        {
          typeid: item.id
        },
        (err, response) => {
          if (response.responsecode == 200) {
            this.editType = 'edit'
            this.inputData = item
            this.editModal = true
          }
          // else if (response.responsecode == 300) {
          //   this.$swal.fire({
          //     text: response.reason,
          //   })
          // }
        }
      )
    },
    showAdd() {
      this.editType = 'add'
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.depatable td {
  vertical-align: baseline;
}
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:not(:last-child) {
        vertical-align: top;
      }
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background-color: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
        vertical-align: top;
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectType.vue